import axios from 'services/axios'
import { CancelTokenSource } from 'axios'
import { ENDPOINTS } from 'const/endpoints'
import { commonMessages } from 'utils/messages'
import { convertUnix, toDate } from 'utils/time'
import _ from 'lodash'
import { IPagination } from 'types/entities'
import { errorNotify } from 'utils/toster'
import { onCreateEndpointsWithClientid } from 'utils/common'
import { IFullMember, IMemberParams, ProgramDropdownList } from './ProgramEnrollments.interfaces'

export function getMember(
	id: string | undefined,
	clientId: string | undefined,
	source?: CancelTokenSource,
) {
	// const promise = axios.get<IFullMember>(ENDPOINTS.PATIENTS + '/' + clientId + '/' + id)
	const promise = axios.get<IFullMember>(
		onCreateEndpointsWithClientid(ENDPOINTS.PATIENTS) + '/' + id,
	)
	//@ts-ignore
	promise.cancel = () => {
		source?.cancel(commonMessages.queryCancelledMessage)
	}
	return promise
}
export function getMemberCalendarEvents(params: Partial<any>, source?: CancelTokenSource) {
	const filteredParams = _.pickBy(params, _.identity)
	delete filteredParams.clientId
	delete filteredParams.patientId
	const promise = axios.get(
		onCreateEndpointsWithClientid(ENDPOINTS.MEMBER_CALENDAR_SLOT) + '/' + params?.patientId,
		{
			params: filteredParams,
		},
	)
	//@ts-ignore
	promise.cancel = () => {
		source?.cancel(commonMessages.queryCancelledMessage)
	}
	return promise
}

export function getMembers(
	client: string | undefined,
	programId: string | undefined,
	enrollmentPeriodId: string | undefined,
	params: Partial<IMemberParams>,
	source?: CancelTokenSource,
) {
	/**
	 * Variable Section
	 */
	const partnerConvert = params?.partner && JSON.parse(params?.partner)
	const partnerFilterParams = partnerConvert?.some((ds: any) => ds)
	if (!partnerFilterParams) {
		delete params?.partner
	}
	const updatedParams = { ...params, currentDate: convertUnix(toDate()) }
	const filteredParams = _.pickBy(updatedParams, _.identity)
	const promise = axios.get<IPagination<Partial<IFullMember>>>(
		ENDPOINTS.PATIENT_LISTING + '/' + client + '/' + programId + '/' + enrollmentPeriodId,
		{
			params: filteredParams,
		},
	)
	//@ts-ignore
	promise.cancel = () => {
		source?.cancel(commonMessages.queryCancelledMessage)
	}
	return promise
}

export function getProgramsReenrollment(
	params: { limit: number | undefined; page?: number | string; search?: string; sort?: string },
	source?: CancelTokenSource,
) {
	const filteredParams = _.pickBy(params, _.identity)
	const promise = axios.get<IPagination<ProgramDropdownList>>(
		onCreateEndpointsWithClientid(ENDPOINTS.RE_ENROLL_PROGRAMS),
		{
			params: filteredParams,
		},
	)

	//@ts-ignore
	// Add cancel method to the promise
	promise.cancel = () => {
		source?.cancel(commonMessages.queryCancelledMessage)
	}

	return promise
}

export function downloadExcel(
	clientId: string | undefined,
	programId: string | undefined,
	enrollmentPeriodId: string | undefined,
	params: any,
	source?: CancelTokenSource,
) {
	const programName = params?.programName || ''
	const filteredParams = _.pickBy(params, _.identity)

	const checkPath = `${ENDPOINTS.EXPORT_RE_ENROLLMENT_EXCEL}/${clientId}/${programId}/${enrollmentPeriodId}`
	const promise = axios
		.get(checkPath, {
			params: filteredParams,
			responseType: 'blob',
		})
		.then((response) => {
			// Create a temporary URL object to generate a download link
			const url = window.URL.createObjectURL(new Blob([response.data]))
			const link = document.createElement('a')
			link.href = url
			link.setAttribute('download', `${`${programName}._patients.xls`}`)

			// Simulate a click event to trigger the download
			document.body.appendChild(link)
			link.click()

			// Clean up the temporary URL object
			document.body.removeChild(link)
			window.URL.revokeObjectURL(url)
		})
		.catch(() => {
			errorNotify('Error downloading PDF')
		})
	//@ts-ignore
	promise.cancel = () => {
		source?.cancel(commonMessages.queryCancelledMessage)
	}
	return promise
}

export function statusToggle(data: any, source?: CancelTokenSource) {
	const promise = axios.post(onCreateEndpointsWithClientid(ENDPOINTS.MEMBER_ENROLLMENT), data)
	//@ts-ignore
	promise.cancel = () => {
		source?.cancel(commonMessages.queryCancelledMessage)
	}
	return promise
}
